class ProductImagesSlider extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.productModal =
      this.closest(".product-page").querySelector("product-modal");
    this.imagesLoader = this.closest(".product__media-wrapper").querySelector(
      ".images-loader"
    );
    this.mediaWrapper = this.closest(".product__media-wrapper");

    // number of slides the slider has (both main & zoom sliders)
    this.slideNum = this.querySelectorAll(".product-images-container .swiper-slide").length;

    this.ZOOMMAX = 2;
    this.ZOOMMIN = 1;
    this.currentZoom = 1;
  }

  connectedCallback() {
    this.initSlider();
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            this.zoomSliderElement.classList.remove("zoom-on");
            document.querySelector("html").classList.remove("overflow-hidden");
        }
    });
  }

  getCloseIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
      </svg>
    `;
  }
  getPlusIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
      </svg>
    `;
  }
  getMinusIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
      </svg>
    `;
  }

  initSlider() {
    
    // main object variables
    this.zoomSliderObject;
    this.sliderObject;
    this.zoomSliderElement = this.querySelector(".product-images_zoomup-container");

    this.querySelector('.product-images-container .zoom-icon').addEventListener('click', () => this.openZoomslider());

    const prod_images = this.querySelector(
      ".product-images-data-contents"
    ).dataset.imgArr.split(",");


    const zoomsliderOptions = {
      navigation: {
        nextEl: ".zoomslider-navbtn-next",
        prevEl: ".zoomslider-navbtn-prev"
      },
      loop: true,
      allowSlideNext: this.slideNum > 1 ? true : false,
      allowSlidePrev: this.slideNum > 1 ? true : false,
      threshold: 30,
      zoom: {
        maxRatio: this.detectMobile() ? 3 : 1.5,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    }
    const swiperOptions = {
      loop: true,
      slidesPerView: 1,
      allowSlideNext: this.slideNum > 1 ? true : false,
      allowSlidePrev: this.slideNum > 1 ? true : false,
      preloadImages: true,
      updateOnImagesReady: true,
      navigation: {
        nextEl: ".product-nav-buttons .swiper-button-next",
        prevEl: ".product-nav-buttons .swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${prod_images[index] == 'hiddenimg' ? 'hidden' : ''} ${className}">
                    <img src="${prod_images[index]}">
                  </span>`;
        },
      },
      on: {
        slideChange: function() {
          const currentSlide = this.realIndex + 1;
          const currentSlideElement = this.el.closest('.product-images-slider').querySelector('.current-slide');
          if (currentSlideElement) {
            currentSlideElement.textContent = currentSlide;
          }
        }
      },
      // on: {
      //   init: function() {
      //     console.log("the images began loading");
      //     var x = window.scrollX;
      //     var y = window.scrollY;
      //     window.onscroll = function() { window.scrollTo(x, y) }
      //   },
      //   afterInit: function() {
      //     console.log("the images are ready to go");
      //     window.onscroll = function() {}
      //   }
      // }
    };

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (width < 750) delete swiperOptions.pagination.renderBullet;

    var mySwiper = new Swiper(".product-images-container", swiperOptions);
    var zoomSwiper = new Swiper(".product-images_zoomup-container", zoomsliderOptions);
    this.zoomSliderObject = zoomSwiper;
    this.sliderObject = mySwiper;
    this.mainSlides = this.querySelectorAll(".product-images-container .zoomslide-trigger");

    if(width < 750 && prod_images.length > 1) {
      const swiperBullets = this.querySelector(".swiper-pagination");
      mySwiper.on('slideChange', function () {
        swiperBullets.querySelector(".swiper-pagination-bullet.swiper-pagination-bullet-active").classList.remove("swiper-pagination-bullet-active");
        swiperBullets.querySelectorAll(".swiper-pagination-bullet")[mySwiper.realIndex].classList.add("swiper-pagination-bullet-active");
      });
    }

    this.zoomsliderActions();
    this.detectTrackpadZoom();

    const paginationBullets = document.querySelectorAll(".swiper-pagination .swiper-pagination-bullet");
    paginationBullets.forEach(function(paginationBullet, index){
      paginationBullet.addEventListener("click", function(){
        //document.querySelector(".product-images-container .zoomslide-trigger[data-swiper-slide-index='" + index + "']").click();
      });
    });

    // assign actions to each slide
    if(this.mainSlides && this.mainSlides.length > 0) {
      this.mainSlides.forEach((slide, index) => {
        slide.addEventListener("click", this.onSlideClick.bind(this, slide, index));
      });
    }

    const swiperPagnation = document.querySelector('.product-images-container'),
          swiperPageItems = swiperPagnation.querySelectorAll('.swiper-pagination-bullet'),
          swiperNextEl = swiperPagnation.querySelector('.swiper-button-next'),
          swiperPrevEl = swiperPagnation.querySelector('.swiper-button-prev');

    if(swiperPageItems.length > 4) {
      window.addEventListener('click', event => {
        if(event.target !== swiperNextEl && event.target !== swiperPrevEl ) { return }
        const activeSlide = swiperPagnation.querySelector('.swiper-pagination-bullet-active');
        document.querySelector('.swiper-pagination').scrollTop = activeSlide.offsetTop;
      });
    }
  }

  detectMobile() {
    var isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }
    return isMobile;
  }

  zoomsliderActions() {
    const zoomClose = this.zoomSliderElement.querySelector("#slider-close");
    const zoomIn = this.zoomSliderElement.querySelector("#slider-zoomin");
    const zoomOut = this.zoomSliderElement.querySelector("#slider-zoomout");

    if(zoomClose) { zoomClose.addEventListener("click", this.closeZoomslider.bind(this)); }
    if(zoomIn) { zoomIn.addEventListener("click", this.zoomIn.bind(this)); }
    if(zoomOut) { zoomOut.addEventListener("click", this.zoomOut.bind(this)); }

    // resets the zoom indicator when the slide changes
    this.zoomSliderObject.on("slideChange", () => {
      this.sliderObject.slideTo(this.zoomSliderObject.activeIndex);

      // resets the previous active image scale to 1
      // this.scaleImage();
    });
  }

  detectTrackpadZoom() {
    window.addEventListener('gesturestart', (e) => {
      const zoom = this.zoomSliderObject.zoom;
      if (zoom && zoom.scale > 1) {
        zoom.out();
      }
    });
  
    window.addEventListener('wheel', (e) => {
      if (e.ctrlKey) {
        const zoom = this.zoomSliderObject.zoom;
        if (zoom && zoom.scale > 1) {
          zoom.out();
        }
      }
    }, { passive: true });
  }

  

  onSlideClick(slide, index) {
    console.log("slide index", index);
    this.zoomSliderObject.slideTo(index);
    this.openZoomslider();
  }
  onZoomSlideChange(slide, index) {
    console.log("slide index", index);
    this.zoomSliderObject.slideTo(index);
    this.openZoomslider();
  }
  zoomIn() {
    // this.currentZoom = this.currentZoom >= this.ZOOMMAX ? this.currentZoom : this.currentZoom + 0.2;
    // this.scaleImage();
    this.zoomSliderObject.zoom.in();
  }
  zoomOut() {
    // this.currentZoom = this.currentZoom <= this.ZOOMMIN ? this.currentZoom : this.currentZoom - 0.2;
    // this.scaleImage();
    this.zoomSliderObject.zoom.out();
  }
  scaleImage() {
    // const activeImage = this.zoomSliderElement.querySelector(".swiper-slide-active .slide-image__wrapper");
    const activeImage = this.zoomSliderElement.querySelector(".swiper-slide-active img");
    const translateScale = ((this.currentZoom - 1)/2) / this.currentZoom; // translate ratio

    // variables for image width & height after scale has been applied
    const imgWidth = activeImage.offsetWidth * this.currentZoom;
    const imgHeight = activeImage.offsetHeight * this.currentZoom;

    // make image larger by scale
    // if it exceeds the screen dimension, translate the image accordingly
    activeImage.style.transform = `scale(${this.currentZoom})`;
  }

  openZoomslider() {
    if(this.detectMobile() && document.body.classList.contains("template-multi-bundles")) {
      return;
    }
    this.zoomSliderElement.classList.add("zoom-on");
    // lock the background content
    document.querySelector("html").classList.add("overflow-hidden");
  }
  closeZoomslider() {
    this.zoomSliderElement.classList.remove("zoom-on");
    // unlock the background content
    document.querySelector("html").classList.remove("overflow-hidden");
    
    setTimeout(() => {
      if (this.zoomSliderObject && this.zoomSliderObject.zoom) {
        this.zoomSliderObject.zoom.out();
        setTimeout(() => {
          this.zoomSliderObject.zoom.out();
        }, 50);
      }
    }, 100);
  }

  reInitSlider(product) {
    // put images container on loading motion
    const oldPosition = window.scrollY;
    if(this.detectMobile()) {
      const wrapper_height = this.mediaWrapper.offsetHeight;
      // this.mediaWrapper.style.height = wrapper_height + 'px';
    }
    this.imagesLoader.classList.add("loading");

    // Preserve the model-text-pdp element before replacing content
    const modelTextPdp = this.querySelector('.model-text-pdp');
    const preservedModelText = modelTextPdp ? modelTextPdp.outerHTML : '';

    const filteredMedia = product.media.filter((media) => media.alt !== "PLP-EXCLUSIVE" && media.media_type === "image");
    const filteredMediaVideo = product.media.filter((media) => media.alt !== "PLP-EXCLUSIVE" && media.media_type === "video");
    const prodImages = filteredMedia && filteredMedia.length > 0 ? filteredMedia : product.media;
    const prodVideos = filteredMediaVideo && filteredMediaVideo.length > 0 ? filteredMediaVideo : [];
    let gender = '';
    let color = '';
    product.tags.forEach((tag) => {
      if(tag.includes('gender_Male')) {
        gender = 'Men';
      }else if(tag.includes('gender_Female')) {
        gender = 'Women';
      }
    });
    product.options.forEach((option) => {
      if(option.name == "Color") {
        color = option.values[0];
      }
    });
    console.log(product)
    // find the largest image height, accordingly to the ratio with screen width
    var largestImageHeight = -1;
    prodImages.forEach((image) => {
      // take the minimum of screen width & maximum image width (500px)
      const imageWidth = 500 > window.innerWidth ? window.innerWidth : 500;
      const adjustedHeight = imageWidth * (image.height / image.width);
      largestImageHeight = largestImageHeight > adjustedHeight ? largestImageHeight : adjustedHeight;
    });
    var largestVideoHeight = -1;
    prodVideos.forEach((video) => {
      const videoWidth = 500 > window.innerWidth ? window.innerWidth : 500;
      const adjustedHeight = videoWidth * (video.height / video.width);
      largestVideoHeight = largestVideoHeight > adjustedHeight ? largestVideoHeight : adjustedHeight;
    })

    // create images modal template
    const newProdSlider = `
      <div class="product-images_zoomup-container swiper-container">
        ${prodImages.length > 1 ? `<div class="zoomslider-navbtn zoomslider-navbtn-prev swiper-button-prev"></div>
          <div class="zoomslider-navbtn zoomslider-navbtn-next swiper-button-next"></div>` : ""}
        <div class="swiper-wrapper">
          ${prodImages.map((prodimage) => {
            return `
              <div class="swiper-slide product__media-item--full" data-media-id="${this.sectionId}-${prodimage.id}">
                <div class="swiper-zoom-container">
                  <img  src="${prodimage.src}" width="${prodimage.width}" loading="lazy" alt="${gender} wearing ${color} ${product.title} ${product.type.split('-').pop()}">
                </div>
              </div>
            `;
          }).join("")}
        </div>
        <!--
        <div class="zoom-actions">
          <div class="zoomslider-actionbtn zoomslider-actionbtn-zoomin" id="slider-zoomin">${this.getPlusIcon()}</div>
          <div class="zoomslider-actionbtn zoomslider-actionbtn-zoomout" id="slider-zoomout">${this.getMinusIcon()}</div>
        </div>
        -->
        <div class="zoomslider-actionbtn zoomslider-actionbtn-close" id="slider-close">${this.getCloseIcon()}</div>
      </div>
      <div class="product-images-container swiper-container">
            <div class="items-badges">
              <span class="badge-item badge-discount hidden"></span>
            </div> 
        <span class="zoom-icon"></span>
        ${prodImages.length > 1 ? `<div class="image-counter-overlay">
          <span class="current-slide">1</span>/<span class="total-slides">${prodImages.length}</span>
        </div>` : ""}
        
        <div class="swiper-pagination-wrapper">
          ${prodImages.length > 1 ? `<div class="swiper-pagination"></div>` : ""}
        </div>
        
        ${prodImages.length > 1 ? `<div class="product-nav-buttons">
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>` : ""}
        ${preservedModelText}
        <div class="swiper-wrapper">
          ${prodImages.map((prodimage, index) => {
            return `
              <div class="swiper-slide zoomslide-trigger product__media-item--full ${prodimage.alt}" data-media-id="${this.sectionId}-${prodimage.id}">
                <img class="img_slider" original="${prodimage.src}" src="${prodimage.src}" width="${prodimage.width}" loading="lazy" alt="${gender} wearing ${color} ${product.title} ${product.type.split('-').pop()}">
              </div>
            `;
          }).join("")}
          ${prodVideos.length > 0 ? `
          <div class="swiper-slide zoomslide-trigger product__media-item--full" data-media-id="${this.sectionId}-${prodVideos[0].id}">
              <video autoplay muted loop playsinline disableremoteplayback preload="to" style="width: 100%;" object-fit="cover">
                <source src="${prodVideos[0].sources[1].url}" type="video/mp4">
              </video>
          </div>
          `: ""}
        </div>
      </div>
      <div class="product-images-data-contents" data-img-arr="${prodImages.map((prodimage) => { return prodimage.src }).join(",")},${prodVideos.map((proVideo) => { return proVideo.preview_image.src }).join(",")}"></div>
      <div class="product-images-data-alt" data-img-arr="${prodImages.map((prodimage) => { return prodimage.alt }).join(",")}"></div>
    `;


    if(this.detectMobile()) {
      this.mediaWrapper.style.height = `${largestImageHeight + 16}px`;
    }
    // adjust the height to the largest image height s.t. the image slider transition is smooth
    // if(this.detectMobile()) {
    //
    //   var timeCounter = 0;
    //   const updateScrollPositionInterval = setInterval(() => {
    //     if(window.scrollY != oldPosition) {
    //       window.scrollTo({
    //         top: oldPosition,
    //         left: 0
    //       });
    //       clearInterval(updateScrollPositionInterval);
    //     } else {
    //       if(timeCounter++ == 30) {
    //       	clearInterval(updateScrollPositionInterval);
    //       }
    //     }
    //   }, 50);
    // }

    this.innerHTML = newProdSlider;
    this.slideNum = prodImages.length;
    this.initSlider();

  	// if(this.detectMobile()) {
    //   this.mediaWrapper.style.height = 'auto';
    //   var timeCounter = 0;
    //   const updateScrollPositionInterval = setInterval(function(){
    //     if(window.scrollY != oldPosition) {
    //       window.scrollTo({
    //         top: oldPosition,
    //         left: 0
    //       });
    //       clearInterval(updateScrollPositionInterval);
    //     } else {
    //       if(timeCounter++ == 30) {
    //       	clearInterval(updateScrollPositionInterval);
    //       }
    //     }
    //   }, 50);
    // }
    this.imagesLoader.classList.remove("loading");
  }
}

customElements.define("product-images-slider", ProductImagesSlider);
